module.exports = __webpack_public_path__ + "img/comments.f812e9bf.svg";